import styled from 'styled-components'

import { palette } from '_styles/variables'

export const Container = styled.label`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`

export const Radio = styled.span`
  display: block;
  position: relative;
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;
  border: 1px solid ${palette.neutral['grey-bbbdbf']};
  border-radius: 100%;

  input:checked ~ && {
    border-color: ${palette.ui.blue};

    &::after {
      content: '';
      position: absolute;
      inset: 0.1875rem;
      background-color: ${palette.ui.blue};
      border-radius: 100%;
    }
  }
`
